<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="资产方编号" prop="assetsPlatformCode">
        <el-input v-model="dataForm.assetsPlatformCode" placeholder="资产方编号"></el-input>
      </el-form-item>
      <el-form-item label="产品编号" prop="productCode">
        <el-select v-model="dataForm.productCode" placeholder="请选择" style="width:100%">
          <el-option v-for="item in productCode" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文件类型" prop="fileTypeCode">
        <el-select v-model="dataForm.fileTypeCode" placeholder="请选择" style="width:100%">
          <el-option v-for="item in fileTypeData" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否必传" prop="checked">
        <el-radio-group v-model="dataForm.checked">
          <el-radio label="0">非必传</el-radio>
          <el-radio label="1">必传</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="版本号" prop="version">
        <el-input v-model="dataForm.version" placeholder="版本号"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce"
export default {
  created(){
     // 文件类型
     this.$http.get(`/sys/dict/data/list?dataType=file_type`).then(r=>{
     this.fileTypeData = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
    })
    // this.$http.get(`/sys/dict/data/list?dataType=signState`).then(r=>{
    //   console.log(r)
    //  this.signState = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
    // })

    this.$http.get('/loan/tproduct/page',{
      page: 1,
      limit: 1000,
    }).then(r => {
     this.productCode = r.data.data ? r.data.data.list.map(item => ({value:item.productCode,label:item.productName
      })) : []
      
    })
    
  },
  data() {
    return {
      visible: false,
      productCodeData: [],
      fileTypeData: [],
      productCode:[],
      dataForm: {
        id: "",
        assetsPlatformCode: "",
        productCode: "",
        fileTypeCode: "",
        checked: "",
        createTime: "",
        createBy: "",
        updateTime: "",
        updateBy: "",
        version: "",
        remark: "",
      },
    }
  },
  computed: {
    dataRule() {
      return {
        assetsPlatformCode: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        productCode: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        fileTypeCode: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        checked: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        version: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        remark: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
      }
    },
  },
  mounted() {
    this.getFileFData()
  },
  methods: {
    // 获取产品编号
    // async getFileFData() {
    //   let params = {
    //     order: "desc",
    //     desc: "",
    //     orderField: "id",
    //     id: "",
    //     page: "1",
    //     limit: "100",
    //     id: "",
    //   }
    //   const dictionaryType = ["file_type", "productNo"]
    //   const file_type_url = "/sys/dict/data/list?dataType=file_type"
    //   const productNo_url = "/sys/companies/list"
    //   dictionaryType.forEach(async (v) => {
    //     if (v === "file_type") {
    //       try {
    //         let result = await this.$http.get(file_type_url)
    //         this.fileTypeData = result.data.data ? result.data.data.map((item) => ({ value: item.dictLabel, label: item.dictLabel })) : []
    //       } catch (error) {
    //         console.log(error)
    //       }
    //     } else {
    //       try {
    //         let result = await this.$http.get(productNo_url, params)
    //         this.productCodeData = result.data.list || []
    //       } catch (error) {
    //         console.log(error)
    //       }
    //     }
    //   })
    // },

    init() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/loan/tproductfileconfig/${this.dataForm.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          }
        })
        .catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false
          }
          this.$http[!this.dataForm.id ? "post" : "put"]("/loan/tproductfileconfig/", this.dataForm)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false
                  this.$emit("refreshDataList")
                },
              })
            })
            .catch(() => {})
        })
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
}
</script>
